<template>
    <div class="small-12 flex justify-center page articles article animated fadeIn" v-if="loaded">
        <header-public/>
        <div class="small-12 pageContentWrap flex justify-center">
            <policies-nav/>
            <div class="small-12 pageContent">
                <div class="small-12">
                    <div class="small-12 articleDetails flex justify-center" v-if="policy">
                        <policy-title :key="policy.id" :policy="policy"/>
                        <policy-feature-image :key="policy.id" :policy="policy" v-if="policy.links.feature_image"/>
                        <policy-content :key="policy.id" :policy="policy"/>
                    </div>
                </div>
            </div>
            <public-footer/>
        </div>
    </div>
    <loading-spinner :loaded="loaded" v-else/>
</template>

<script>

	// Import the mixins
    import { GetPolicy } from '@/events/policies/GetPolicy'
	import { GetAppVersion } from '@/events/app/GetAppVersion'

	// Import the components    
	import LoadingSpinner from '@/components/framework/helpers/LoadingSpinner.vue'
	import PublicFooter from '@/components/framework/footer/PublicFooter.vue'
    import HeaderPublic from '@/components/framework/header/HeaderPublic.vue'
    import PolicyTitle from '@/components/policies/policy/PolicyTitle.vue'
	import PolicyFeatureImage from '@/components/policies/policy/PolicyFeatureImage.vue'
	import PolicyContent from '@/components/policies/policy/PolicyContent.vue'
    import PoliciesNav from '@/components/policies/shared/PoliciesNav.vue'
	import NewVersionModal from '@/components/framework/modals/NewVersionModal.vue'

	export default {

		/*
		** Set the component name
		*/

		name: 'Index',

		/*
		**  Register the components
		*/

		components: {

			LoadingSpinner,
            HeaderPublic,
			PolicyTitle,
			PolicyFeatureImage,
			PolicyContent,
			PublicFooter,
            PoliciesNav,
			NewVersionModal

		},

		/*
		**  Register the mixins
		*/

		mixins: [

            GetPolicy,
			GetAppVersion

		],

		/*
		**  Set the props
		*/

		props: {

			//

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			loaded: false

		}),

		/*
		**  Watch em'
		*/

		watch: {

			'$route.params.slug': function (slug) {
				
				/*
				**  Get the article
				**  @location: @here
				*/

				this.getPolicy();

			},

			policy: {

				immediate: true, // Load on created
				handler(policy) {

					/*
					**  Load the page
					**  @method: @here
					*/

					if (policy) this.loaded = true;

				}

			},

		},

		/*
		**  Do this first
		*/

		created() {

			/*
			**  Get the article
			**  @location: @here
			*/

			this.getPolicy();

		},

		/*
		**  Set up the methods
		*/

		methods: {

			getPolicy: function() {

				try {

					/*
					**  Set the loaded prop
					**  @prop_location: @here
					*/

					this.loaded = false;

					/*
					**  Get the article
					**  @location: Events/Policies/GetPolicy
					*/

					this.getPolicyHandler();

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to load policy.',
						errorType: 'Application',
						section: 'Policies',
						uid: 'zsHq2jOz3Q2jlWd6Ykct',
						error: e
					});

				}

			}

		}

	}

</script>